const getFile = async() => {
    return await fetch('assets/i18n/pt.json')
    .then(response => response.json())
    .then((info: any) => {
    return  info.data;
    })
}
export const locale =  {
    lang: 'pt',
    data: getFile()
};
